import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Events } from '../components/Events';
import { PilotInfo } from '../components/PilotInfo';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-548" />
      <Stats data-id="element-549" />
      <Services data-id="element-550" />
      <Events data-id="element-551" />
      <PilotInfo data-id="element-552" />
      <Contact data-id="element-553" />
    </>;
}